import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';

import Dropzone from 'react-dropzone';
import filesize from 'filesize';

import { Message, Icon, Image, Button } from 'semantic-ui-react';
import Tooltip from 'material-ui/Tooltip';
import { ModalTemplate, Loading, Button as Btn } from 'components';

import * as common from 'libs/commonFunc';

import classNames from 'classnames/bind';
import styles from './ExamAttachFile.css';
const cx = classNames.bind(styles);

class ExamAttachFile extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const {
      onProgress,
      isAuth,
      attachFileVisible,
      attachFile,
      uploadResult,
      resetAttachFile,
      uploadAttachFile,
      handleOnDropAttachFile,
      handleOnToggleAttachFileModal
    } = this.props;

    const isAcceptAttachFile = !!attachFile && !!attachFile.accept.length;
    const isRejectAttachFile = !!attachFile && !!attachFile.reject.length;

    // 업로드 성공
    // errInfo 처리

    let uploadResultInfo = null;
    if (!!uploadResult.isUpload) {
      uploadResultInfo = (
        <Message icon success={uploadResult.isUpload === 1} error={uploadResult.isUpload !== 1}>
          <Icon name={uploadResult.isUpload === 1 ? 'check' : 'remove'} />
          <Message.Content>
            <Message.Header>
              {defineMessages(formatMessage({ id: 'ExamTemplateAttachFile_1', defaultMessage: '업로드' })) +
                ' ' +
                (uploadResult.isUpload === 1
                  ? defineMessages(formatMessage({ id: 'ExamTemplateAttachFile_2', defaultMessage: '성공' }))
                  : defineMessages(formatMessage({ id: 'ExamTemplateAttachFile_3', defaultMessage: '실패' })))}
            </Message.Header>
            {uploadResult.message}
          </Message.Content>
        </Message>
      );
    }

    return (
      <div className={cx('modal-content')}>
        <div className={cx('upload-wrapper')}>
          <Loading
            active={onProgress}
            size="small"
            content={defineMessages(formatMessage({ id: 'ExamTemplateAttachFile_8', defaultMessage: '업로드중...' }))}
          />
          <div
            className={cx(
              'dropzone',
              'template-attach-file',
              {
                acceptDrop: isAcceptAttachFile
              },
              {
                rejectDrop: isRejectAttachFile
              }
            )}>
            <Dropzone
              onDrop={handleOnDropAttachFile}
              multiple={false}
              activeClassName="activeDrop"
              name="file"
              title={defineMessages(
                formatMessage({ id: 'ExamTemplateAttachFile_9', defaultMessage: '클릭하여 파일을 선택하세요.' })
              )}>
              {({ isDragActive }) => {
                const isActiveMessage = isDragActive && (
                  <div className={cx('isDragActive-guide')}>
                    {defineMessages(
                      formatMessage({
                        id: 'ExamTemplateAttachFile_10',
                        defaultMessage: '파일을 끌어 놓아서 추가 할 수 있습니다.'
                      })
                    )}
                  </div>
                );

                // 정상적인 템플릿 파일을 등록
                if (isAcceptAttachFile) {
                  return attachFile.accept.map(f => (
                    <div className={cx('uploadFile-area')} key={f.name}>
                      {isActiveMessage}
                      <div className={cx('acceptFile')}>
                        <Icon name="file text outline" size="huge" className={cx('upload-icon')} />
                        <div className={cx('uploadFile-info')}>
                          <div className={cx('file-name')}>{f.name}</div>
                          <div className={cx('file-size')}>{filesize(f.size)}</div>
                        </div>
                        <Tooltip
                          title={defineMessages(
                            formatMessage({ id: 'ExamTemplateAttachFile_11', defaultMessage: '업로드 파일 삭제' })
                          )}
                          placement="right">
                          <Icon
                            name="trash"
                            className={cx('bt-resetFile')}
                            onClick={e => {
                              e.stopPropagation();
                              resetAttachFile();
                            }}
                          />
                        </Tooltip>
                      </div>
                    </div>
                  ));
                } else {
                  // 파일 올리기 전
                  return (
                    <div className={cx('upload-guide')}>
                      {isDragActive && (
                        <div className={cx('isDragActive-guide')}>
                          {defineMessages(
                            formatMessage({
                              id: 'ExamTemplateAttachFile_10',
                              defaultMessage: '파일을 끌어 놓아서 추가 할 수 있습니다.'
                            })
                          )}
                        </div>
                      )}
                      {/* <Icon name="cloud upload" size="large" /> */}
                      <Image src="/img/modal/upload.png" />
                      <span>
                        {defineMessages(
                          formatMessage({
                            id: 'ExamTemplateAttachFile_12',
                            defaultMessage: '업로드 파일을 끌어 놓거나, 클릭하세요.'
                          })
                        )}
                      </span>
                    </div>
                  );
                }
              }}
            </Dropzone>
          </div>
          {/* 업로드 결과 */}
          {/* <Btn buttonColor="#3cb482" loading={onProgress} disabled={onProgress} onClick={uploadAttachFile}>
            {defineMessages(formatMessage({ id: 'ExamTemplateAttachFile_6', defaultMessage: '업로드' }))}
          </Btn> */}
          {uploadResultInfo}
        </div>
      </div>
    );
  }
}

ExamAttachFile.propTypes = {
  //
};
ExamAttachFile.defaultProps = {
  //
};

export default injectIntl(ExamAttachFile);



// WEBPACK FOOTER //
// ./src/script/components/examTemplate/ExamAttachFile.js